import { getApiBaseUrl } from "../utils/formatters";

const API_BASE_URL =getApiBaseUrl();// process.env.REACT_APP_API_URL || 'https://localhost:7267/api';
const getAuthHeaders = () => {
  const token = localStorage.getItem("token");

  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }) // ✅ only if exists
  };
};

class ApiService {
  
  async get(endpoint) {
    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: 'GET',
        headers: getAuthHeaders()   // ✅ here
        /*headers: { 
          'Content-Type': 'application/json'
        }*/
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('API GET Error:', error);
      throw error;
    }
  }

  async post(endpoint, data) {
    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: 'POST',
              headers: getAuthHeaders(),   // ✅ here
        /*headers: { 
          'Content-Type': 'application/json'
        },*/
        body: JSON.stringify(data)
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('API POST Error:', error);
      throw error;
    }
  }

  async put(endpoint, data) {
    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: 'PUT',
        /*headers: { 
          'Content-Type': 'application/json'
        },*/
              headers: getAuthHeaders(),   // ✅ here
        body: JSON.stringify(data)
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      // PUT often returns 204 No Content
      if (response.status === 204) {
        return { success: true };
      }
      
      return await response.json();
    } catch (error) {
      console.error('API PUT Error:', error);
      throw error;
    }
  }

  async delete(endpoint) {
    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: 'DELETE',
        /*headers: { 
          'Content-Type': 'application/json'
        }*/
             headers: getAuthHeaders(),   // ✅ here
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return { success: true };
    } catch (error) {
      console.error('API DELETE Error:', error);
      throw error;
    }
  }
}

export default new ApiService();